import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import {
  NEW_CARGO_CATEGORY_PATH,
  CARGO_CATEGORY_PATH,
} from '../../../../config/paths';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import ModuleList from '../../../layout/ModuleList';
import { CARGO_CATEGORY_COLUMNS } from '../../../../config/columns';
import {
  clearCargoCategories,
  getCargoCategories,
} from '../../../../actions/cargo/CargoCategory';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';

export class CargoCategories extends Component {
  constructor(props) {
    super(props);
    this.columns = CARGO_CATEGORY_COLUMNS;
  }

  componentWillUnmount() {
    this.props.dispatchClearCargoCategories();
  }

  render() {
    const {
      cargoCategories,
      loading,
      breadcrumbs,
      dispatchGetCargoCategories,
    } = this.props;

    const data = cargoCategories.get('content') || [];
    const pages = cargoCategories.get('totalPages') || null;
    const defaultPageSize = cargoCategories.get('size') || DEFAULT_PAGE_SIZE;

    return (
      <ModuleList
        title="Categorías"
        buttonPath={NEW_CARGO_CATEGORY_PATH}
        breadcrumbs={breadcrumbs}
        tableStructure={{
          columns: this.columns,
          data,
          pages,
          defaultPageSize,
          filterable: true,
          fetchData: dispatchGetCargoCategories,
          modelPath: CARGO_CATEGORY_PATH,
          loading,
          navigateToModelOnRowClick: true,
        }}
      />
    );
  }
}

const mapDispatchToProps = {
  dispatchGetCargoCategories: getCargoCategories,
  dispatchClearCargoCategories: clearCargoCategories,
};

const mapStateToProps = ({ CargoUnit }) => ({
  breadcrumbs: [
    ...CargoUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Categorías',
      href: CARGO_CATEGORY_PATH,
    },
  ],
  cargoCategories: CargoUnit.CargoCategory.getIn(['all', 'content']),
  loading: CargoUnit.CargoCategory.getIn(['all', 'loading']),
});

CargoCategories.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  cargoCategories: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetCargoCategories: PropTypes.func.isRequired,
  dispatchClearCargoCategories: PropTypes.func.isRequired,
};

CargoCategories.defaultProps = {
  cargoCategories: null,
  loading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(CargoCategories);
